import React, { useState, useMemo, useEffect } from "react";
import "./Login_signup.css";
import { Form, Modal } from "react-bootstrap";
import Select_login from "./Select_login";
import Login_modal from "./Login_modal";
import Signup_Modal from "./Signup_Modal";
import Reset_Password_Modal from "./Reset_Password_Modal";
import Successfull_Modal from "../common-modal/successfull_modal/Successfull_Modal";
import Login_With_Email from "./Login_With_Email";
import Login_With_Mobile from "./Login_With_Mobile";
import Set_New_Password_Modal from "./Set_New_Password_Modal";

const Login_Layout_Modal = (props) => {

  const [selectedModal, setSelectedModal] = useState("");
  const [email, setEmail] = useState("");
  const [contact, setContact] = useState("");

  useEffect(() => {
    setSelectedModal(props?.modalType)
  }, [props]);


  // console.log("selectedModal", selectedModal);

  const [showSignUp, setShowSignUp] = useState(true);
  const [value, setValue] = useState("");
  const [showResetModal, setShowResetModal] = useState(false);
  const [showSetPassModal, setShowSetPassModal] = useState(false);
  const [showSucsessModal, setShowSucsessModal] = useState(false);
  const [successText, setSuccessText] = useState("");



  return (
    <>
      {/* Select_login Modal */}
      <Modal className="Login_Modal" size="md" {...props} centered>
        <div className="absolute_div">
          <p className="modal_title">{selectedModal === "sign_up" ? "SIGN UP" : "LOGIN"}</p>
          <div className="logo_holder">
            <img
              src={process.env.PUBLIC_URL + "/assets/images/logo/logo.png"}
              className="logo_img"
              alt="Logo"
            />
          </div>
        </div>

        <Modal.Body>
          <div className="close_img_div">
            <img
              src={process.env.PUBLIC_URL + "/assets/images/icons/close.png"}
              className="close_img"
              // onClick={() => props?.onHide()}
              onClick={() => {
                props?.onHide();         // Close the modal
                // window.location.reload(); // Refresh the page
              }}
              alt="Close"
            />
          </div>

          <div className="main_layout">
            {selectedModal === "select_login" ? (
              <Select_login
                setSelectedModal={setSelectedModal}
                onHide={props?.onHide}
                setShowSucsessModal={setShowSucsessModal}
                setSuccessText={setSuccessText}
              />
            ) : selectedModal === "sign_up" ? (
              <Signup_Modal
                setSelectedModal={setSelectedModal}
                setShowSucsessModal={setShowSucsessModal}
                onHide={props?.onHide}
                setSuccessText={setSuccessText}
              />
            ) : selectedModal === "login_with_mobile" ? (
              <Login_With_Mobile
                setSelectedModal={setSelectedModal}
                onHide={props?.onHide}
                setShowResetModal={setShowResetModal}
                setShowSucsessModal={setShowSucsessModal}
                setSuccessText={setSuccessText}
              />
            )
              //  : selectedModal === "login_with_email" ? (
              //   <Login_With_Email
              //     setSelectedModal={setSelectedModal}
              //     onHide={props?.onHide}
              //     setShowResetModal={setShowResetModal}
              //     setShowSucsessModal={setShowSucsessModal}
              //     setSuccessText={setSuccessText}
              //   />
              // )
              :
              null}
          </div>
        </Modal.Body>
      </Modal>

      <Successfull_Modal
        show={showSucsessModal}
        onHide={() => {
          setShowSucsessModal(false);
        }}
        headtext={successText}
        subtext={"See You Soon!"}
        subtext2={"Have a nice time ahead"}
      />

      <Reset_Password_Modal
        show={showResetModal}
        onHide={() => setShowResetModal(false)}
        setShowSetPassModal={() => setShowSetPassModal(true)}
        setEmail={setEmail}
        setContact={setContact}
        email={email}
        contact={contact}
      />


      <Set_New_Password_Modal
        show={showSetPassModal}
        onHide={() => setShowSetPassModal(false)}
        setShowSucsessModal={() => setShowSucsessModal(true)}
        email={email}
        contact={contact}
      />

    </>
  );
};

export default Login_Layout_Modal;
